const GeographyRoutes = [
	{
		path: '/geography',
		component: () => import('@/components/default'),
		children: [
			{
				path: '',
				redirect: '/geography/regions',
			},

			{
				path: 'regions',
				component: () => import('@/components/default'),
				children: [
					{
						path: '',
						name: 'geography-regions',
						component: () => import('@/components/geography/Regions'),
					},
					{
						path: 'sub',
						name: 'geography-sub-regions',
						component: () => import('@/components/geography/SubRegions'),
					},
				],
			},
			{
				path: 'community',
				name: 'geography-community',
				component: () => import('@/components/geography/Community'),
			},
		],
	},
];

export default GeographyRoutes;
